<div *ngIf="eChartOptions">
  <ng-container [ngSwitch]="eChartOptions?.chartType">
    <ng-template [ngSwitchCase]="'bar'">
      <mat-card class="bar-chart-cards">
        <mat-card-content>
          <div>
            <h5>{{ eChartOptions?.title }}</h5>
            <small>{{ eChartOptions?.subTitle }}</small>
          </div>
          <div class="feature-message">
            <div class="bar-alone">
              <ngx-charts-bar-vertical-stacked
                class="responsive-display"
                [view]="view"
                [scheme]="colorScheme"
                [results]="resultsData"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel"
                [showGridLines]="showGridLines"
                [legend]="showLegend"
                [legendTitle]="''"
                [legendPosition]="legendPosition"
                [animations]="animations"
                [barPadding]="20"
              >
              </ngx-charts-bar-vertical-stacked>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>
    <ng-template [ngSwitchCase]="'singleSeriesBar'">
      <div class="bar-chart-cards single-series-bar">
        <div class="feature-message">
          <div class="bar-alone">
            <ngx-charts-bar-vertical
              class="responsive-display"
              [view]="view"
              [scheme]="colorScheme"
              [results]="resultsData"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [showGridLines]="showGridLines"
              [legend]="showLegend"
              [legendTitle]="''"
              [legendPosition]="legendPosition"
              [animations]="animations"
              [barPadding]=""
              [roundEdges]="roundEdges"
              [yAxisTickFormatting]="allowYAxisTickFormatting"
            >
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
